import React from "react";

const Minus = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 248">
      <path id="Vector 26" d="M24 12.001H0" stroke="#EC2526" strokeWidth="2" />
    </g>
  </svg>
);

export default Minus;
